import { OperatorFunction, pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormOption } from '../../models/form-option.interface';
import { ToFormOptionConfig } from '../../models/to-form-option-config.interface';
import { formatFormOption } from '../../utils/form-option/form-option.utils';

/**
 * Formats iterable to FormOption Array
 *
 * ### Parameters
 * @param {selectValue} selectValue
 * Property used to set value of FormOption.
 * Can either be a key of entity or a mutation function
 *
 * @param {selectLabel} selectValue
 * Property used to set value of FormOption.
 * Can either be a key of entity or a mutation function
 *
 * ### Returns
 * @return Observable<FormOption[]
 */
export function toFormOption<T>(
  config?: ToFormOptionConfig<T>,
): OperatorFunction<T[] | undefined, FormOption[]> {
  return pipe(
    map((entities: T[] | undefined) => formatFormOption(entities, config)),
  );
}
